// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"76":"actioncable","440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "-" + {"76":"5144b53952f9cc3073cc","440":"5ff83b8cf346e2fba0c1","581":"728c9c33bbdb6c74ae6c"}[chunkId] + ".chunk.js";
};